export default __webpack_public_path__ + "static/media/menuClose.71bbe1fd.svg";